module.exports = __webpack_public_path__ + "static/img/pu.b152cc46.png";